import React from 'react';
import './ArchitecturalPlan.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection'; // Correct import for the component
import architectural_dummy_1 from '../../assets/images/architectural_plan_hmg.jpg'; // Correct path for the background image
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
//import img_architectural_banner from '../../assets/images/img_peso1_banner.png';
import { FaTools, FaBuilding, FaRegClock, FaCertificate, FaRegPaperPlane } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ArchitecturalPlan() {
    const architecturalBenefits = [
        {
          icon: <FaTools />,
          title: 'Efficient Design',
          text: 'Create designs that maximize space while ensuring functionality and aesthetic appeal.',
        },
        {
          icon: <FaBuilding />,
          title: 'Compliance Assurance',
          text: 'Ensure your designs meet local regulations and safety standards.',
        },
        {
          icon: <FaRegClock />,
          title: 'Timely Delivery',
          text: 'Receive timely and well-executed architectural plans to meet project deadlines.',
        },
        {
          icon: <FaCertificate />,
          title: 'Certified Expertise',
          text: 'Our team provides professional and certified expertise in architectural design.',
        },
      ];
    
      const steps = [
        {
          icon: <FaRegPaperPlane />,
          title: 'Initial Consultation',
          description: 'Discuss your project’s scope and your vision for the architectural design.',
        },
        {
          icon: <FaTools />,
          title: 'Design Drafting',
          description: 'We create the first draft of your architectural design, tailored to your needs.',
        },
        {
          icon: <FaBuilding />,
          title: 'Regulatory Check',
          description: 'We review the design for compliance with local building codes and safety standards.',
        },
        {
          icon: <FaRegClock />,
          title: 'Design Finalization',
          description: 'Finalize the architectural design with all revisions and approvals.',
        },
        {
          icon: <FaCertificate />,
          title: 'Project Handover',
          description: 'Receive your completed architectural plan, ready for implementation.',
        },
      ];
    
      const acts = [
        "National Building Code 2005",
        "Indian Standard for Structural Design",
        "Fire Safety and Structural Codes",
      ];
    
      const explanation = "These regulations ensure your architectural plans are not only innovative but also compliant with safety and environmental standards.";
    
      const checklistItems = [
        { name: 'Building Site Plan', description: 'Submit the site plan, showing the property boundaries and dimensions.' },
        { name: 'Zoning and Land Use Approval', description: 'Provide the zoning approval and land-use certificate from local authorities.' },
        { name: 'Construction Timeline', description: 'Outline the projected timeline for the project completion.' },
        { name: 'Materials List', description: 'Provide a list of materials to be used in construction.' },
      ];
    
  return (
    <>
     <Header4 />
      <ServicesHeroSection
        headline="Architectural Plan Design"
        subheading="Create functional and aesthetically appealing architectural plans with expert design and compliance."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/architectural-design" }}
        backgroundImage={architectural_dummy_1}  // Pass the image path here
      />

      <ServicesOverviewSection
        title="What is Architectural Plan Design?"
        description="Architectural plan design involves creating detailed drawings and plans for the construction of buildings. Our team ensures that your designs are both visually striking and structurally sound, while meeting all necessary regulations."
        // image={img_architectural_banner} // Image for the architectural design process
        // altText="Architectural Design Process"
      />

      <ServicesBenefitsSection
        title="Why Choose Our Architectural Plan Design Service?"
        description="Discover the benefits of working with our experienced architects to bring your vision to life."
        benefits={architecturalBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Regulations"
        subtitle="Building and Construction Safety Standards"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Architectural Design Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Architectural Plan Design Onboarding"
        checklistTitle="Architectural Plan Design Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
    
  )
}
